import 'babel-polyfill' // polyfill promises and other ES6 features
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import filters from './filters'
import 'bootstrap/less/bootstrap.less'
import './foundations.css'
import './globalstyles.less'
import 'font-awesome/css/font-awesome.css'
import InstantSearch from 'vue-instantsearch'
import {useAirbrake} from './airbrake'
import * as Sentry from '@sentry/vue';


import {
  Popover,
  Dropdown,
  Modal,
  Collapse,
  Tooltip,
  Alert,
  Typeahead,
  DatePicker,
  Tabs,
  Tab,
  scrollspy
} from 'uiv'

// start analytics tracking and fetch user info
store
  .dispatch('initTracking')
  .then(() => {
    return store.dispatch('user/getUserInfo')
  })
  .then(data => {
    if (store.getters['user/isSuperAdmin']) {
      store.commit('visibility/toggleEditorMode', true)
    }
    if (store.getters['user/isTestUser']) {
      store.commit('visibility/toggleBetaMode', true)
    }
    if (data && data.diagnostics) {
      // wrap this inside a try/catch so exceptions don't disrupt the flow of execution for the app
      try {
        document.getElementById('ci-build-info').innerHTML = `build ${data.diagnostics.build}, ${data.diagnostics.sha1}`
        console.info(data.diagnostics)
        store.commit('user/setDiagnostics', data.diagnostics)
      } catch {
        // do nothing
      }
    }
  })

// define global filters
Object.keys(filters).forEach(filter => {
  Vue.filter(filter, filters[filter])
})

Vue.component('modal', Modal)
Vue.component('dropdown', Dropdown)
Vue.component('popover', Popover)
Vue.component('collapse', Collapse)
Vue.component('tooltip', Tooltip)
Vue.component('alert', Alert)
Vue.component('typeahead', Typeahead)
Vue.component('datepicker', DatePicker)
Vue.component('tabs', Tabs)
Vue.component('tab', Tab)
Vue.directive('scrollspy', scrollspy)

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

import vStickybits from '@/util/stickybits.directive'
Vue.directive('stickybits', vStickybits)

import vueSmoothScroll from '@/util/vue-smooth-scroll.directive'
Vue.use(vueSmoothScroll)

import { sendEvent, GbAnalyticsPlugin } from '@/tracking'
Vue.use(GbAnalyticsPlugin)

Vue.use(InstantSearch)

Vue.config.productionTip = false

const routerWithAirbrake = useAirbrake(router)

if (window.__SENTRY_ENABLED__) {
  Sentry.init({
    Vue,
    dsn: 'https://7b8d48511b6a5e074ce5c9614d966736@o4511223585243136.ingest.us.sentry.io/4511223588585472',
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.user) {
        delete event.user.email
        delete event.user.ip_address
      }
      if (event.request) {
        delete event.request.cookies
        if (event.request.headers) {
          delete event.request.headers['Cookie']
          delete event.request.headers['cookie']
        }
      }
      return event
    },
  })
}

import { setupHandleRequest } from './api/request_handler'
import { showLoginModal } from './router/showLoginModal'

setupHandleRequest(showLoginModal)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: routerWithAirbrake,
  store,
  render: h => h(App)
})
window.__VUE_APP_MOUNTED__ = true